module.exports = __webpack_public_path__ + "static/media/md-football.f661b75c.svg";